<div class="services-partial-container">
  <div>
    <h1>Дополнительные услуги</h1>

    <div class="container">
      <div class="container__item">
        <el-form-item class="align-items--flex-end_el-form-item__content margin-bottom--40-p">
          <el-col :span="11">
            <el-form-item prop="services.powerOfAttorney">
              <el-switch
                v-model="dataForm.services.powerOfAttorney"
                active-text="Доверенность"
                @change="(value) => toggleResetFields(value, ['services.typePowerOfAttorney'])"
              />
            </el-form-item>
          </el-col>

          <el-col :span="2" />

          <el-col :span="11">
            <el-form-item
              label="Тип доверенности"
              class="services-partial-container__label-padding--0"
              prop="services.typePowerOfAttorney"
              :required="dataForm.services.powerOfAttorney"
            >
              <el-select
                v-model="dataForm.services.typePowerOfAttorney"
                :disabled="!dataForm.services.powerOfAttorney"
                placeholder="Выберите вариант"
              >
                <el-option
                  v-for="option in optionsTypePowerOfAttorney"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item class="align-items--flex-end_el-form-item__content margin-bottom--40-p">
          <el-col :span="11">
            <el-form-item prop="services.dataForTheDriver">
              <el-switch
                v-model="dataForm.services.dataForTheDriver"
                active-text="Нужны данные на водителя"
                @change="(value) => toggleResetFields(value, ['services.sendTo'])"
              />
            </el-form-item>
          </el-col>

          <el-col :span="2" />

          <el-col :span="11">
            <el-form-item
              label="Отправить на"
              class="services-partial-container__cash-on-delivery"
              prop="services.sendTo"
              :required="dataForm.services.dataForTheDriver"
            >
              <el-select
                v-model="dataForm.services.sendTo"
                placeholder="Выберите вариант"
                :disabled="!dataForm.services.dataForTheDriver"
              >
                <el-option
                  v-for="communication in communications"
                  :key="communication.value"
                  :label="communication.label"
                  :value="communication.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item
          class="align-items--flex-end_el-form-item__content margin-bottom--40"
        >
          <el-col :span="11">
            <el-form-item prop="services.cashOnDelivery">
              <el-switch
                v-model="dataForm.services.cashOnDelivery"
                @click="dataForm.services.cashOnDeliverySum = null"
                active-text="Наложенный платёж"
                :disabled="dataForm.services.cargoRedemption"
                @change="(value) => toggleResetFields(value, ['services.cashOnDeliverySum'])"
              />
            </el-form-item>
          </el-col>

          <el-col :span="2" />

          <el-col :span="11">
            <el-form-item
              label="Сумма наложенного платежа"
              class="services-partial-container__label-padding--0"
              prop="services.cashOnDeliverySum"
              :required="dataForm.services.cashOnDelivery"
            >
              <el-input
                type="number"
                v-model="dataForm.services.cashOnDeliverySum"
                :disabled="!dataForm.services.cashOnDelivery"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
      </div>

      <div class="container__item">
        <el-form-item
          class="align-items--flex-end_el-form-item__content margin-bottom--40-p"
        >
          <el-col :span="11">
            <el-form-item prop="services.cargoRedemption">
              <el-switch
                v-model="dataForm.services.cargoRedemption"
                active-text="Выкуп груза"
                :disabled="dataForm.services.cashOnDelivery"
                @change="(value) => toggleResetFields(value, ['services.whoPaysTheRansom', 'services.cargoRedemptionSum'])"
              />
            </el-form-item>
          </el-col>
          <el-col :span="2" />

          <el-col :span="11">
            <el-form-item
              label="За чей счёт"
              class="services-partial-container__label-padding--0"
              prop="services.whoPaysTheRansom"
              :required="dataForm.services.cargoRedemption"
            >
              <el-select
                v-model="dataForm.services.whoPaysTheRansom"
                placeholder="Выберите вариант"
                :disabled="!dataForm.services.cargoRedemption"
                @change="checkRedemption('whoPaysTheRansom')"
              >
                <el-option
                  v-for="option in optionsWhoPaysTheRansom"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                  :disabled="dataForm.sender.cityFrom !== 'Челябинск' && option.label === 'За счет ТК ЛУЧ'"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item
          class="align-items--flex-centre_el-form-item__content margin-bottom--40"
        >
          <el-col :span="11">
            <el-form-item>
              <span
                v-if="dataForm.services.whoPaysTheRansom === '1'"
                class="label_font-size--10"
              >
                *Город выкупа груза - Челябинск, до 6000 р., заказчик -
                получатель.
              </span>
            </el-form-item>
          </el-col>

          <el-col :span="2" />

          <el-col :span="11">
            <el-form-item
              label="Сумма выкупа груза"
              class="services-partial-container__label-padding--0"
              prop="services.cargoRedemptionSum"
              :required="dataForm.services.cargoRedemption"
            >
              <el-input
                type="number"
                v-model="dataForm.services.cargoRedemptionSum"
                :disabled="!dataForm.services.cargoRedemption"
                min="0"
                :max="dataForm.services.whoPaysTheRansom === '1' ? '6000' : ''"
                @change="checkRedemption('cargoRedemptionSum')"
              />
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item
          class="align-items--flex-centre_el-form-item__content margin-bottom--40"
        >
          <el-col :span="11">
            <el-form-item prop="services.warmPlace">
              <el-switch
                v-model="dataForm.services.warmPlace"
                active-text="Тёплое место"
                :disabled="checkDisabledWarmplace()"
              />
            </el-form-item>
            <div class="warmplace__text" v-if="dataForm.cargoInformation.cargoWeight > 30">Максимальная масса - 30кг</div>
          </el-col>

          <el-col :span="2" />

          <el-col :span="11">
            
          </el-col>
        </el-form-item>
      </div>
    </div>

    <el-form-item prop="services.returnOfDocuments">
      <el-switch
        v-model="dataForm.services.returnOfDocuments"
        active-text="Возврат документов"
      />
    </el-form-item>
  </div>

  <div class="bord_button">
    <el-form-item>
      <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-back')"
      >
        Назад
      </el-button>
    </el-form-item>
    <el-form-item>
      <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-next', [...getArrayOfRules(dataForm.services, 'services')])"
      >
        Далее
      </el-button>
    </el-form-item>
  </div>
</div>
